/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import IepIcon from 'icons/IepIcon';

const messages = defineMessages({
  title: {id: 'navigation.iep'},
});

const IepItem = () => (
  <StudentRouteLinkItem
    iconBefore={IepIcon}
    route="midas/student/iep"
    title={messages.title}
  />
);

export default IepItem;
